import Layout from '@components/layout/Main'
import ClientDocEditor from '@components/documents/ClientDocEditor'
import Seo from 'src/seo/components/Seo'
import FAQ from '@components/shared/FAQ'
import JsonLdDoc from 'src/seo/jsonld/JsonLdDoc'
import DocArticle from '@components/html/DocArticle'
import useT from '@hooks/useTranslation'

import dbConnect from 'db/dbConnect'
import useUrlSeo from 'src/seo/server/useUrlSeo'

const SellBuyRegistration = ({ seo }) =>
    <Layout navdown>
        <Layout.NavSpace />
        <Seo seo={seo} />
        <JsonLdDoc title="Zgłoszenie sprzedaży/kupna samochodu" />
        <ClientDocEditor
            createDocument="sale_buy_registration_doc"
            descriptionPage={{
                title: useT('Zgłoszenie sprzedaży/kupna samochodu'),
                name: 'buySellRegistration',
                timestamp: Date.now(),
            }}
            mapModel="saleBuyRegMapper"
            model={{}}
            seo={seo}
            type="buy_sell_registration"
        />
        <DocArticle seo={seo} />
        <FAQ qa={seo.faqFile} page="buy_sale_registration" />
    </Layout>

export default SellBuyRegistration

export async function getServerSideProps (context) {
    await dbConnect()
    return {
        props: {seo: await useUrlSeo({ context, resolvedUrl: '/zgloszenie-sprzedazy-zbycia-nabycia-pojazdu-samochodu-auta' })},
    }
}